import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "react-router-dom";

const faqs = [
  {
    q: "Quels livres sont disponibles ?",
    a: "BARON BOOKS propose actuellement trois ouvrages : Le fauteuil du chef, Femme dans toutes ses dimensions et Les cris d'une femme.",
  },
  {
    q: "Combien coûte un livre ?",
    a: "Chaque livre est proposé au prix de 19,99 €.",
  },
  {
    q: "Dans quel format les livres sont-ils disponibles ?",
    a: "Les livres sont proposés en format numérique PDF lorsque ce format est disponible à l'achat.",
  },
  {
    q: "Puis-je lire le livre sur mon téléphone ?",
    a: "Oui, les livres numériques peuvent être consultés sur smartphone, tablette ou ordinateur avec une application compatible.",
  },
  {
    q: "Comment recevoir mon livre ?",
    a: "Après confirmation du paiement, le client reçoit les instructions ou le lien permettant d'accéder au livre numérique.",
  },
  {
    q: "Puis-je acheter depuis l'étranger ?",
    a: "Oui, le site est préparé pour permettre les achats de clients internationaux.",
  },
  {
    q: "Comment se déroule un achat sur BARON BOOKS ?",
    a: "Choisissez un livre → ajoutez-le au panier → passez commande → payez en sécurité via Stripe → recevez immédiatement l'accès au téléchargement dans votre bibliothèque personnelle.",
  },
  {
    q: "Comment accéder à mes livres après l'achat ?",
    a: "Connectez-vous à votre compte puis rendez-vous dans « Ma bibliothèque ». Chaque livre acheté y apparaît avec un bouton de téléchargement sécurisé.",
  },
  {
    q: "Puis-je acheter sans créer de compte ?",
    a: "Pour l'instant, la création d'un compte est nécessaire afin de vous garantir un accès permanent à vos livres, même après plusieurs mois.",
  },
  {
    q: "Quels moyens de paiement acceptez-vous ?",
    a: "Nous acceptons les cartes bancaires internationales (Visa, Mastercard, American Express) via Stripe. D'autres moyens (PayPal, Apple Pay, Google Pay) arriveront prochainement.",
  },
  {
    q: "Puis-je être remboursé(e) ?",
    a: "En raison de la nature immédiate et téléchargeable des livres numériques, les achats sont non-remboursables une fois le fichier téléchargé. Pour toute demande particulière, contactez-nous.",
  },
  {
    q: "Le paiement est-il sécurisé ?",
    a: "Oui. Toutes les transactions sont chiffrées et traitées par Stripe (norme PCI-DSS niveau 1). Nous ne stockons jamais vos coordonnées bancaires.",
  },
  {
    q: "Puis-je partager le PDF avec d'autres personnes ?",
    a: "Chaque livre est destiné à un usage personnel. Merci de respecter le travail de l'auteur en n'en diffusant pas de copies.",
  },
];

export default function FAQ() {
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 py-16 fade-in">
      <div className="label-eyebrow text-accent mb-3">Aide</div>
      <h1 className="font-serif text-5xl md:text-6xl tracking-tight">Questions fréquentes</h1>
      <p className="mt-4 text-muted-foreground">Vous ne trouvez pas votre réponse ? <Link to="/contact" className="text-accent hover:underline">Contactez-nous</Link>.</p>

      <div className="mt-12">
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="font-serif text-lg text-left hover:text-accent">{f.q}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
